"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockLogger = void 0;
/**
 * Logger implmentation that stores the logs in memory. Good for unit tests that need a log implementation and can check the logs received in the logBuffer.
 */
class MockLogger {
    constructor() {
        this.logBuffer = {
            info: [],
            warn: [],
            debug: [],
            error: [],
            critical: []
        };
    }
    info(message, ...optionalParms) {
        this.logBuffer.info.push({ message: message, optionalParms: optionalParms });
    }
    warn(message, ...optionalParms) {
        this.logBuffer.warn.push({ message: message, optionalParms: optionalParms });
    }
    debug(message, ...optionalParms) {
        this.logBuffer.debug.push({ message: message, optionalParms: optionalParms });
    }
    error(message, ...optionalParms) {
        this.logBuffer.error.push({ message: message, optionalParms: optionalParms });
    }
    critical(message, ...optionalParms) {
        this.logBuffer.critical.push({ message: message, optionalParms: optionalParms });
    }
}
exports.MockLogger = MockLogger;
